/* 🤖 this file was generated by svg-to-ts */
export const iccIconState: {
  name: 'state';
  data: string;
} = {
  name: 'state',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z" fill="currentColor"/></svg>`
};
